import { render, staticRenderFns } from "./SampleBatchProcessing.vue?vue&type=template&id=100d0ac6&scoped=true&"
import script from "./SampleBatchProcessing.vue?vue&type=script&lang=js&"
export * from "./SampleBatchProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100d0ac6",
  null
  
)

export default component.exports